"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRolesDto = instanceOfRolesDto;
exports.RolesDtoFromJSON = RolesDtoFromJSON;
exports.RolesDtoFromJSONTyped = RolesDtoFromJSONTyped;
exports.RolesDtoToJSON = RolesDtoToJSON;
exports.RolesDtoToJSONTyped = RolesDtoToJSONTyped;
const Roles_1 = require("./Roles");
/**
 * Check if a given object implements the RolesDto interface.
 */
function instanceOfRolesDto(value) {
    if (!('roles' in value) || value['roles'] === undefined)
        return false;
    return true;
}
function RolesDtoFromJSON(json) {
    return RolesDtoFromJSONTyped(json, false);
}
function RolesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'roles': (json['roles'].map(Roles_1.RolesFromJSON)),
    };
}
function RolesDtoToJSON(json) {
    return RolesDtoToJSONTyped(json, false);
}
function RolesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'roles': (value['roles'].map(Roles_1.RolesToJSON)),
    };
}
//# sourceMappingURL=RolesDto.js.map